import styled from 'styled-components'

import { Box as BoxBase } from '@icontainers/design-system/dist/atoms/Box'
import { Link as LinkBase } from '@src/Application/Interfaces/Atoms/Link'

export const Box = styled(BoxBase)`
    border-radius: 10px;
    max-width: 570px;
    width: 100%;
    padding: 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`

export const TitleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const Title = styled.h2`
    color: ${(props) => props.theme.color.g500};
    ${(props) => props.theme.typo.displayM}
    ${(props) => props.theme.fontWeight.bold}
`

export const Description = styled.div`
    ${(props) => props.theme.typo.bodyM}
    line-height: 180%;
    color: ${(props) => props.theme.color.g500};
`

export const ArticleTitle = styled.h3`
    color: ${(props) => props.theme.color.p500};
    ${(props) => props.theme.typo.bodyM}
    margin-top: 15px;
`

export const Link = styled(LinkBase)`
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`

export const TopWrapper = styled.div``

export const BottomWrapper = styled.div`
    margin-top: 22px;
    text-align: right;
    width: 100%;
`

export const ViewAllLink = styled(LinkBase)`
    ${(props) => props.theme.typo.bodyM}
    ${(props) => props.theme.fontWeight.medium}
    color: ${(props) => props.theme.color.p500};
    text-transform: uppercase;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`
